import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from '../context/LanguageContext';

const PasswordInput = ({ value, onChange, label, placeholder, required = false, name }) => {
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();
  
  // 如果没有传入placeholder，使用默认翻译
  const displayPlaceholder = placeholder || t('components.password_input.enter_password');

  return (
    <div className="space-y-1.5">
      {label && <label className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</label>}
      <div className="relative">
        <input 
          type={showPassword ? "text" : "password"}
          name={name}
          className="w-full py-2.5 px-4 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all pr-10 dark:bg-slate-800 dark:text-white"
          value={value}
          onChange={onChange}
          placeholder={displayPlaceholder}
          required={required}
        />
        <button 
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 transition-colors"
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;
